export default __webpack_public_path__ + "static/media/plantillaSubirProductosProveedor.6385776e.xlsx";